import { useState, useEffect, useRef } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { verifyOTP, sendOTP, updatePhoneNumber } from "../services/authServices";
import GrubToastMessage from "../../../components/alert/GrubToastMessage";
import { GrubErrorHook, GrubPopupErrorHook } from "../../../hooks/index";
import * as Constants from "../../../constants/Constants";
import { userSignIn } from "../services/authServices";


export const usePhoneVerification = (props) => {
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(60); // 1 minutes in seconds
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const { error } = GrubErrorHook();
    const { error } = GrubPopupErrorHook();
    const [errorMessage, setErrorMessage] = useState(false);
    const { addToast } = GrubToastMessage();
    const [loading, setLoading] = useState(false);
    const [isSignUpOpen, setIsSignUpOpen] = useState(false);
    const [showOtp, setShowOtp] = useState(props.otpCode);
    const [isOpenMessage, setIsOpenMessage] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const isSubmittingRef = useRef(false);

    useEffect(() => {
        setIsOpenMessage(true);
        setNotificationMessage({isError: false, message: Constants.OTP_SENT_TO_MOBILE_NUMBER});
        setTimeout(() => {
            setNotificationMessage({});
        }, 5000);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const handleOtpChange = (value) => {
        setOtp(value);
        if(value.length == 6 && !loading){
            handleVerifyOTP(value);
            setErrorMessage({error: false, message: ""});
        }
    };

    const handleResendOTP = async () => {
        if (timer > 0) return;
        setLoading(true);
        try {
            setIsSubmitting(true);
            sendOTP({
                phone_number: `${props.phoneNumber}`
            }).then(response => {
                if (
                    undefined !== response.data.flag &&
                    null !== response.data.flag &&
                    response.data.flag == true
                ) {
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_SUCESS,
                    //     alertTitle: 'Success',
                    //     alertDescription: response.data.message
                    // });
                    setIsOpenMessage(true);
                    // setNotificationMessage(response.data.message);
                    setNotificationMessage({isError: false, message: response.data.message});
                    setTimeout(() => {
                        setNotificationMessage({});
                    }, 5000);
                    if(response?.data?.data?.otp_token){
                        localStorage.setItem("otp_token", response?.data?.data?.otp_token);
                    }
                    // props.handleBackButton(false);
                    // props.handlePhoneVerificationOpen(props.phoneNumber);
                    // props.onOTPSent(formik.values.phone);
                    setLoading(false);
                    setTimer(60);
                    setOtp("");
                    setShowOtp(response?.data?.data?.otp_code);
                    isSubmittingRef.current = false;
                }
            })
            .catch(err => {
                let actionData = err;
                // error({ actionData: err });
                let popupError = error({ actionData });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
                isSubmittingRef.current = false;
                setLoading(false);
            });
        } catch (err) {
            // error({ actionData: err });
            let popupError = error({ actionData: err });
            if (popupError.error) {
                setErrorMessage(popupError);
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
            }
            setIsSubmitting(false);
            setLoading(false);
        }
    };

    const handleVerifyOTP = async (otp) => {
        if (otp.length !== 6) {
            setErrorMessage({error: true, message: Constants.OTP_REQUIRED});
            setTimeout(() => {
                setErrorMessage({});
            }, 5000);
            return;
        }
        else{
            setErrorMessage({error: false, message: ""});
        }
        try {
            setLoading(true);
            setIsSubmitting(true);
            // const response = await verifyOTP({
            //     phone_number: props.phoneNumber,
            //     otp: otp
            // });
            // if (response.data.flag) {
            //     addToast({
            //         alertStatus: Constants.TOAST_TYPE_SUCESS,
            //         alertTitle: 'Verified',
            //         alertDescription: response.data.message
            //     });
            //     if(response?.data?.data?.direct_login == false){
            //         // setIsSignUpOpen(true);
            //         props.handleSignUpOpenFromPhoneVerification(props.phoneNumber);
            //         // props.handleBackButton(false);
            //     }
            //     else{
            //         props.onVerifySuccess && props.onVerifySuccess(response.data);
            //         setLoading(true);
            //         let data = {
            //             phone_number: props.phoneNumber,
            //             sign_in_type: "phone"
            //         };
            //         try {
            //             userSignIn(data)
            //                 .then(response => {
            //                     if (
            //                         undefined !== response.data.flag &&
            //                         null !== response.data.flag &&
            //                         response.data.flag == true
            //                     ) {
            //                         // addToast({
            //                         //     alertStatus: Constants.TOAST_TYPE_SUCESS,
            //                         //     alertTitle: Constants.USER_LOGING,
            //                         //     alertDescription: response.data.message
            //                         // });
            //                         props.handleBackButton(false);
            //                         props.userLogin(response.data.data.user[0]);
            //                         localStorage.setItem("token", response.data.data.token);
            //                         props.handleBackButton(false);
            //                     }
            //                 })
            //                 .catch(err => {
            //                     let actionData = err;
            //                     error({ actionData });
            //                 });
            //         } catch (error) {
            //             let actionData = error;
            //             error({ actionData });
            //         }
            //     }
            // }
            // setLoading(false);
            verifyOTP({
                phone_number: props.phoneNumber,
                otp: otp
            }).then(response => {
                if (response.data.flag) {
                    if(props.phoneUpdate){
                        setLoading(false);
                        handleUpdatePhoneNumber(props.phoneNumber);
                    }
                    else{
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_SUCESS,
                    //     alertTitle: 'Verified',
                    //     alertDescription: response.data.message
                    // });
                    setIsOpenMessage(true);
                    // setNotificationMessage(response.data.message);
                    // setNotificationMessage({isError: false, message: response.data.message});
                    // setTimeout(() => {
                    //     setNotificationMessage({});
                    // }, 5000);
                    if(response?.data?.data?.direct_login == false){
                        if(response?.data?.data?.signup_token){
                            localStorage.setItem("signup_token", response?.data?.data?.signup_token);
                        }
                        if(!props.isSignUpOpen){
                            // setIsSignUpOpen(true);
                            props.handleSignUpOpenFromPhoneVerification(props.phoneNumber,false);
                            // props.handleBackButton(false);
                        }
                        else{
                            props.handleSignUpOpenFromPhoneVerification(props.phoneNumber,true);
                        }
                    }
                    else{
                        props.onVerifySuccess && props.onVerifySuccess(response.data);
                        setLoading(true);
                        let data = {
                            phone_number: props.phoneNumber,
                            sign_in_type: "phone"
                        };
                        try {
                            userSignIn(data)
                                .then(response => {
                                    if (
                                        undefined !== response.data.flag &&
                                        null !== response.data.flag &&
                                        response.data.flag == true
                                    ) {
                                        // addToast({
                                        //     alertStatus: Constants.TOAST_TYPE_SUCESS,
                                        //     alertTitle: Constants.USER_LOGING,
                                        //     alertDescription: response.data.message
                                        // });
                                        props.userLogin(response.data.data.user[0]);
                                        localStorage.setItem("token", response.data.data.token);
                                        addToast({
                                            alertStatus: Constants.TOAST_TYPE_SUCESS,
                                            alertTitle: Constants.USER_LOGING,
                                            alertDescription: response.data.message
                                        });
                                        props.handleBackButton(true);
                                    }
                                })
                                .catch(err => {
                                    setOtp("");
                                    if(err.response.data.code == Constants.API_LOG_TOO_MANY_ATTEMPTS_CODE){
                                        props.handleBackButton(false);
                                    }
                                    let actionData = err;
                                    // error({ actionData: err });
                                    let popupError = error({ actionData });
                                    if (popupError.error) {
                                        setErrorMessage(popupError);
                                        setTimeout(() => {
                                            setErrorMessage({});
                                        }, 5000);
                                    }
                                });
                        } catch (err) {
                            setOtp("");
                            if(err.response.data.code == Constants.API_LOG_TOO_MANY_ATTEMPTS_CODE){
                                props.handleBackButton(false);
                            }
                            if(err.response.data.code == Constants.API_LOG_OTP_EXPIRED_CODE){
                                // props.handleBackButton(false);
                                setTimer(0);
                            }
                            let actionData = err;
                            // error({ actionData: err });
                            let popupError = error({ actionData });
                            if (popupError.error) {
                                setErrorMessage(popupError);
                                setTimeout(() => {
                                    setErrorMessage({});
                                }, 5000);
                            }
                        }
                    }
                    }
                }
            })
            .catch(err => {
                setOtp("");
                if(err.response.data.code == Constants.API_LOG_TOO_MANY_ATTEMPTS_CODE){
                    localStorage.removeItem("otp_token");
                    props.handleBackButton(false);
                }
                if(err.response.data.code == Constants.API_LOG_OTP_EXPIRED_CODE){
                    localStorage.removeItem("otp_token");
                    // props.handleBackButton(false);
                    setTimer(0);
                }
                let actionData = err;
                // error({ actionData: err });
                let popupError = error({ actionData });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
                isSubmittingRef.current = false;
                setLoading(false);
            });
        } catch (err) {
            if(err.response.data.code == Constants.API_LOG_TOO_MANY_ATTEMPTS_CODE){
                props.handleBackButton(false);
            }
            if(err.response.data.code == Constants.API_LOG_OTP_EXPIRED_CODE){
                // props.handleBackButton(false);
                setTimer(0);
            }
            let actionData = err;
            // error({ actionData: err });
            let popupError = error({ actionData });
            if (popupError.error) {
                setErrorMessage(popupError);
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
            }
            setOtp("");
            setIsSubmitting(false);
            setLoading(false);
        }
    };

    const handleUpdatePhoneNumber = async (phoneNumber) => {
        setLoading(true);
        try {
            updatePhoneNumber({
                phone_number: phoneNumber,
                user_id: props.user.user.id
            })
                .then((response) => {
                    if (
                        undefined !== response.data.flag &&
                        null !== response.data.flag &&
                        response.data.flag == true
                    ) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_SUCESS,
                            alertTitle: Constants.TOAST_HEADING_SUCCESS,
                            alertDescription: response.data.message,
                        });
                        localStorage.removeItem("otp_token");
                        props.userLogin(response.data.data);
                        props.handleBackButton(true);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    let actionData = err;
                    const { shouldOpenAuthModal } = error({
                        actionData,
                    });
                    if (shouldOpenAuthModal) {
                        props.handleBackButton(false);
                    }
                    setNotificationMessage({isError: true, message: err.response.data.message});
                    setTimeout(() => {
                        setNotificationMessage({});
                    }, 5000);
                    setOtp("");
                    setLoading(false);
                    return;
                });
        } catch (error) {
            let actionData = error;
            addToast({
                isBottomToast: true,
                alertStatus: Constants.TOAST_TYPE_WARNING,
                alertTitle: Constants.TOAST_HEADING_WARNING,
                alertDescription: actionData.response.data.message,
            });
            setOtp("");
            setLoading(false);
            return;
        }
    }

    const handleBackButton = () => {
        props.handleBackButton(false);
        // setOtp("");
        // setTimer(60);
        // setIsSubmitting(false);
        // if (props.inputRef && props.inputRef.current) {
        //     props.inputRef.current.focus();
        // }
        // props.onBack && props.onBack();
    };

    const handleSignInOpen = () => {
        setIsSignUpOpen(false);
    };

    const handleBackButtonSignUp = () => {
        setIsSignUpOpen(false);
    };

    return {
        otp,
        timer,
        isSubmitting,
        loading,
        isSignUpOpen,
        showOtp,
        isOpenMessage,
        notificationMessage,
        errorMessage,
        formatTime,
        handleOtpChange,
        handleResendOTP,
        handleVerifyOTP,
        handleBackButton,
        handleSignInOpen,
        handleBackButtonSignUp,
    };
};
